import { Component, Prop, Vue } from 'vue-property-decorator';

import IRouterLink from '@/interfaces/IRouterLink';

@Component({
    name: 'CardHeader'
})
export default class CardHeader extends Vue {
    @Prop(String)
    headerTitle!: string;

    @Prop({type: Boolean, default: false})
    backBtn!: boolean;

    @Prop(Boolean)
    button!: boolean;

    @Prop(String)
    buttonColor!: string;

    @Prop(String)
    buttonTitle!: string;

    @Prop(String)
    buttonText!: string;

    @Prop(String)
    buttonIcon!: string;

    @Prop(String)
    modalId!: string;

    @Prop(Function)
    buttonEvent!: any;

    @Prop(Boolean)
    disabled!: boolean;

    @Prop(Object)
    routerLink!: IRouterLink;

    get typeBtn() {
        return this.buttonIcon ? 'pull-right btn-sm' : 'pull-right';
    }

    get backStep() {
        if(!this.backBtn) {
            return (
                this.$store.state.route.from.path !== '/' &&
                this.$store.state.route.from.path !== '/login'
            );
        }
    }

    goBack() {
        this.$router.go(-1);
    }

    eventClick() {
        this.routerLink
            ? this.$router.push(this.routerLink)
            : this.buttonEvent();
    }
}
